
export enum Grouping {
    ManagementGroup0None = 'managementGroup1None',
    ManagementGroup1FirstName = 'managementGroup3FirstName',
    ManagementGroup2LastName = 'managementGroup4LastName',
    ManagementGroup3UserName = 'managementGroup5UserName',
    ManagementGroup4Licences = 'managementGroup2Licences',
    ManagementGroup5Roles = 'managementGroup6Roles',
}